import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { withStyles } from "@material-ui/core/styles";
import './DropdownMenu.scss'
const styles = theme => ({
  root: {
    display: "flex",
    zIndex: "10",

  },
  paper: {
    marginRight: theme.spacing.unit * 2,
  },
  popperRoot: {
    maxWidth: "220px",
    width : "100%",
    // transform:" translateY(159px)"
  },
  buttonRoot: {
    maxWidth: "210px",
    width : "100%",
    fontSize: "16px",
    justifyContent: "start",
    [theme.breakpoints.down('xs')] : {
      fontSize : "12px",
      padding : "0"
    }
  }
});

class DropdownMenu extends React.Component {
  state = {
    open: false
  };

  handleToggle = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  render() {
    const { classes, menuTitle, content ,arrow} = this.props;
    const { open } = this.state;
  
    return (
      <div className={classes.root}>
        <Button
          className={classes.buttonRoot}
          buttonRef={node => {
            this.anchorEl = node;
          }}
          aria-owns={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          disableRipple
          onClick={this.handleToggle}
        >
          <span 
          lang={this.props.value}
          className={open ? "dropdownMenu-menuTitle-active"  : "dropdownMenu-menuTitle"}>
          {menuTitle}
          </span>
          <span 
          className={open ? "dropdownMenu-arrow-active"  : "dropdownMenu-arrow"}>
          {arrow}
          </span>
        </Button>
        <Popper
          open={open}
          anchorEl={this.anchorEl}
          transition
          disablePortal
          placement="top"
          className={classes.popperRoot}
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} id="menu-list-grow">
              <Paper>
                <ClickAwayListener onClickAway={this.handleClose}>
                  {content}
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

export default withStyles(styles)(DropdownMenu);
